import React from 'react';
import CampSiteLinks from '../components/CampSiteLinks';
import WelcomeMessage from '../components/WelcomeMessage';
import ContentFeeds from '../components/ContentFeeds';
import LogoLettering from '../components/LogoLettering';

const IndexPage = ({ data }) => {
    return (
        <div>
            <LogoLettering />
            <CampSiteLinks />
            <WelcomeMessage />
            {/*<ContentFeeds data={data} />*/}
        </div>
    );
};

export default IndexPage;

// export const pageQuery = graphql`
//     query homePageQuery {
//         allWordpressPost(filter: { categories: { name: { eq: "YCFC" } } }) {
//             edges {
//                 node {
//                     id
//                     title
//                     slug
//                     excerpt
//                     content
//                 }
//             }
//         }
//     }
// `;



// WEBPACK FOOTER //
// ./src/pages/index.js